var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickSicon1Mob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3617 4.31348C12.0261 2.8457 14.2115 1.95357 16.604 1.95357C21.8148 1.95357 26.0462 6.185 26.0462 11.3958C26.0462 16.6066 21.8148 20.8381 16.604 20.8381C14.2115 20.8381 12.0261 19.9459 10.3617 18.4781C9.95793 18.1213 9.3393 18.1591 8.98245 18.5641C8.6256 18.9678 8.66467 19.5852 9.06841 19.942C11.078 21.7159 13.7166 22.7916 16.604 22.7916C22.8932 22.7916 27.9998 17.685 27.9998 11.3958C27.9998 5.10663 22.8932 0 16.604 0C13.7166 0 11.078 1.07576 9.06841 2.8496C8.66467 3.20646 8.6256 3.82378 8.98245 4.22752C9.3393 4.63256 9.95793 4.67033 10.3617 4.31348Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1094 5.66624V10.8758C15.1094 11.1349 15.2123 11.3837 15.3959 11.566L19.5635 15.7336C19.9438 16.1152 20.5637 16.1152 20.944 15.7336C21.3256 15.3533 21.3256 14.7334 20.944 14.3531L17.0629 10.4707V5.66624C17.0629 5.12705 16.6253 4.68945 16.0862 4.68945C15.547 4.68945 15.1094 5.12705 15.1094 5.66624Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.976784 7.8149H8.79105C9.33024 7.8149 9.76784 7.3773 9.76784 6.83811C9.76784 6.29893 9.33024 5.86133 8.79105 5.86133H0.976784C0.437599 5.86133 0 6.29893 0 6.83811C0 7.3773 0.437599 7.8149 0.976784 7.8149Z",
    fill: "#1361F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27757 12.3715H10.0918C10.631 12.3715 11.0686 11.9339 11.0686 11.3948C11.0686 10.8556 10.631 10.418 10.0918 10.418H2.27757C1.73838 10.418 1.30078 10.8556 1.30078 11.3948C1.30078 11.9339 1.73838 12.3715 2.27757 12.3715Z",
    fill: "#1361F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97678 16.9536H12.7911C13.3302 16.9536 13.7678 16.516 13.7678 15.9768C13.7678 15.4376 13.3302 15 12.7911 15H4.97678C4.4376 15 4 15.4376 4 15.9768C4 16.516 4.4376 16.9536 4.97678 16.9536Z",
    fill: "#1361F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSicon1Mob);
export default __webpack_public_path__ + "static/media/quick_sicon1_mob.aafe34a27820638ac0662c286b1ea4b1.svg";
export { ForwardRef as ReactComponent };